import { createSlice } from '@reduxjs/toolkit';

import { dismissAlertCase } from './cases/dismissAlert';
import { registerAlertCase } from './cases/registerAlert';
import { initialAlertsState } from './initialState';

const slice = createSlice({
  name: 'Alerts',
  initialState: initialAlertsState,
  reducers: {
    registerAlert: registerAlertCase,
    dismissAlert: dismissAlertCase,
  },
});

const { reducer } = slice;

export const { registerAlert, dismissAlert } = slice.actions;

export default reducer;
